import React from 'react';
import { SiteInfo } from '@/globals';
import { getCategoriesByProducts } from '@/js/repository/CategoryRepository';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import Head from "next/head";

export async function getServerSideProps(context: any) {
  const { locale } = context;
  const siteUrl = `https://${context.req.headers.host}`;

  const categories = await getCategoriesByProducts(locale);

  return {
    props: { categories, siteUrl },
  }
}

export default function TermsOfService(props: any) {
  const { locale } = useRouter();
  const { t } = useTranslation(); 

  const lastUpdated = new Date('2025-05-28').toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });

  const getTermsOfServiceContent = () => {
    switch (locale) {
      case 'ko':
        return (
          <>
            <h1 className="text-2xl font-bold">서비스 이용약관</h1>

            <h2 className="text-xl font-bold mt-4">약관 동의</h2>
            <p>{SiteInfo.siteName}에 오신 것을 환영합니다. 본 서비스 이용약관(&quot;약관&quot;)은 당사 웹사이트 및 서비스 이용에 적용됩니다. 웹사이트에 접속하거나 서비스를 이용함으로써 귀하는 본 약관 및 개인정보처리방침에 동의하는 것으로 간주됩니다. <b>본 약관에 동의하지 않으면 서비스를 이용하지 마십시오.</b></p>

            <p><b>최종 업데이트:</b> 본 약관은 {lastUpdated}에 마지막으로 업데이트되었으며, 수시로 변경될 수 있습니다. 변경 후에도 서비스를 계속 이용하면 변경된 약관에 동의하는 것으로 간주됩니다.</p>

            <h2 className="text-xl font-bold mt-4">서비스 설명</h2>
            <p>{SiteInfo.siteName}은 <b>거래 큐레이션 및 제휴 마케팅 플랫폼</b>으로, AliExpress 및 기타 전자상거래 플랫폼에서 엄선한 상품 추천을 사용자에게 제공합니다. 주요 서비스는 다음과 같습니다:</p>

            <p><b>거래 큐레이션:</b> 할인율, 판매 실적, 품질 평점, 판매자 신뢰도를 기반으로 당사 독자 알고리즘을 사용하여 최적의 거래를 분석 및 제공해드립니다.</p>

            <p><b>제휴 링크:</b> 사용자에게 제휴 전자상거래 플랫폼으로 연결되는 링크를 제공하며, 해당 링크를 통한 구매 시 당사가 커미션을 받을 수 있습니다.</p>

            <p><b>정보 제공 서비스:</b> 상품 정보, 가격 데이터 및 분석을 제공하여 사용자들이 현명한 구매 결정을 내릴 수 있도록 돕습니다.</p>

            <h2 className="text-xl font-bold mt-4">제휴 공지</h2>
            <p><b>중요 안내:</b> {SiteInfo.siteName}은 제휴 마케팅 프로그램에 참여하고 있습니다. 사이트 내 상품 링크를 클릭하여 구매하시면, 추가 비용 없이 판매자로부터 커미션을 받을 수 있습니다.</p>

            <p><b>커미션 구조:</b> 당사의 수익은 완료된 구매에 기반하며, 사용자가 지불하는 가격에 영향을 주지 않습니다. 수령하는 커미션은 서비스 운영 지원 및 무료 거래 큐레이션 제공 유지에 사용됩니다.</p>

            <p><b>편집 독립성:</b> 제휴 커미션을 받더라도 거래 선정 및 순위는 객관적 평가 알고리즘에 의하며, 커미션 비율이나 상업적 관계에 영향을 받지 않습니다.</p>

            <h2 className="text-xl font-bold mt-4">사용자 책임</h2>
            <p>서비스 사용자로서 귀하는 다음에 동의합니다:</p>

            <p><b>합법적 이용:</b> 본 웹사이트를 합법적인 목적과 본 약관 및 관련 법규에 따라 사용합니다.</p>

            <p><b>정확한 정보 제공:</b> 문의 또는 웹사이트 상 상호작용 시 정확한 정보를 제공합니다.</p>

            <p><b>계정 보안:</b> 계정 생성 시 로그인 정보 보안을 유지하고 무단 접근 시 즉시 당사에 통지합니다.</p>

            <p><b>금지 행위:</b> 웹사이트를 손상시키거나 과부하를 주거나 장애를 유발하거나 타인의 서비스 이용을 방해하는 행위를 하지 않습니다.</p>

            <p><b>준수:</b> 제휴 링크를 통한 구매 시 해당 제3자 플랫폼(예: AliExpress)의 서비스 약관 및 정책을 준수합니다.</p>

            <h2 className="text-xl font-bold mt-4">금지된 사용</h2>
            <p>다음과 같은 목적으로 본 웹사이트를 사용할 수 없습니다:</p>

            <p><b>자동화 접근:</b> 당사의 명시적 서면 허가 없이 봇, 스크래퍼, 자동 시스템을 사용해 웹사이트에 접근하거나 데이터를 추출하는 행위.</p>

            <p><b>상업적 착취:</b> 무단으로 콘텐츠를 복제, 복사, 판매하거나 상업적 목적으로 이용하는 행위.</p>

            <p><b>지적재산권 침해:</b> 당사 또는 제3자의 지적재산권을 침해하는 행위.</p>

            <p><b>사기 행위:</b> 제휴 추적 시스템 조작 등 사기성, 기만적, 오도성 행위.</p>

            <p><b>시스템 방해:</b> 웹사이트 보안, 서버, 네트워크를 방해하거나 침해하려는 시도.</p>

            <h2 className="text-xl font-bold mt-4">지적재산권</h2>
            <p><b>당사 콘텐츠:</b> {SiteInfo.siteName} 내 모든 콘텐츠(텍스트, 그래픽, 로고, 알고리즘, 소프트웨어 등)는 당사 또는 라이선스 제공자가 소유하며 저작권, 상표권 및 기타 지적재산권법에 의해 보호됩니다.</p>

            <p><b>제한적 라이선스:</b> 본 약관에 따라 개인적이고 비상업적인 목적으로 웹사이트에 접근하고 이용할 수 있는 비독점적, 양도 불가능한 제한 라이선스를 부여합니다.</p>

            <p><b>제3자 콘텐츠:</b> 제3자 플랫폼의 상품 이미지, 설명 등은 각 소유자가 소유하며 관련 계약 및 공정 사용 원칙에 따라 이용됩니다.</p>

            <p><b>사용자 콘텐츠:</b> 귀하가 제출하는 콘텐츠(피드백, 통신 등)는 서비스 개선 목적으로 사용될 수 있으며, 이를 사용할 수 있는 비독점적 권한을 당사에 부여합니다.</p>

            <h2 className="text-xl font-bold mt-4">면책 및 책임 제한</h2>
            <p><b>서비스 가용성:</b> 연속적인 서비스 제공을 위해 노력하지만 중단 없는 접속을 보장하지 않습니다. 유지보수, 업데이트 또는 기술 문제로 일시적 접속 불가가 발생할 수 있습니다.</p>

            <p><b>정보 정확성:</b> 정확하고 최신 정보를 제공하기 위해 노력하나 모든 상품 정보, 가격, 재고의 완전성, 정확성, 시의성을 보장하지 않습니다.</p>

            <p><b>제3자 거래:</b> 당사는 귀하와 제3자 판매자 간 거래의 당사자가 아니며, 제품 품질, 배송, 반품, 고객 서비스 문제에 대해 책임지지 않습니다.</p>

            <p><b>무보증:</b> 서비스는 &quot;있는 그대로&quot; 및 &quot;이용 가능한 상태로&quot; 제공되며, 명시적 또는 묵시적 보증(상품성, 특정 목적 적합성, 비침해 등)을 포함하지 않습니다.</p>

            <p><b>책임 제한:</b> 법률이 허용하는 최대 범위 내에서, 당사는 간접적, 부수적, 특별, 결과적, 징벌적 손해에 대해 책임지지 않습니다(수익, 데이터, 사업 기회 손실 포함).</p>

            <h2 className="text-xl font-bold mt-4">제3자 서비스</h2>
            <p><b>외부 링크:</b> 당사 웹사이트에는 제3자 사이트 및 서비스 링크가 포함되어 있으며, 해당 사이트의 콘텐츠, 개인정보처리방침, 관행에 대해 당사는 책임지지 않습니다.</p>

            <p><b>판매자 관계:</b> 귀하와 판매자(예: AliExpress) 간 관계는 당사와 무관하며, 구매 관련 분쟁은 해당 판매자와 직접 해결해야 합니다.</p>

            <p><b>제3자 약관:</b> 당사 링크를 통한 제3자 서비스 이용 시, 해당 제3자의 서비스 약관 및 정책도 적용됩니다.</p>

            <h2 className="text-xl font-bold mt-4">데이터 및 개인정보</h2>
            <p>귀하의 개인정보 보호는 당사에 중요합니다. 개인정보 수집, 이용, 보호는 본 약관에 포함된 개인정보처리방침에 따릅니다. <b>개인정보처리방침을 반드시 확인해 주세요.</b></p>

            <p><b>데이터 이용:</b> 익명화된 집계 데이터는 분석, 서비스 개선, 사업 목적으로 사용할 수 있습니다.</p>

            <p><b>쿠키:</b> 개인정보처리방침에 명시된 대로 쿠키 및 유사 기술을 사용하며, 웹사이트 이용 시 이에 동의하는 것으로 간주됩니다.</p>

            <h2 className="text-xl font-bold mt-4">서비스 변경</h2>
            <p>당사는 사전 공지 없이 서비스의 일부 또는 전부를 수정, 일시 중단 또는 종료할 권리를 보유합니다. 포함 사항은 다음과 같습니다:</p>

            <p><b>알고리즘 업데이트:</b> 서비스 품질 향상을 위한 거래 점수 및 큐레이션 알고리즘 변경.</p>

            <p><b>기능 변경:</b> 웹사이트 기능 추가, 수정 또는 삭제.</p>

            <p><b>파트너 관계:</b> 제휴 파트너십 및 제공 거래 변경.</p>

            <p>이용에 중대한 영향을 미치는 변경 사항에 대해서는 사용자에게 합리적 범위 내에서 통지합니다.</p>

            <h2 className="text-xl font-bold mt-4">서비스 종료</h2>
            <p><b>사용자에 의한 종료:</b> 언제든지 별도 통지 없이 서비스 이용을 중단할 수 있습니다.</p>

            <p><b>당사에 의한 종료:</b> 본 약관 위반 또는 서비스 및 타 사용자에 해로운 행위 시, 사전 통지 없이 즉시 서비스 이용을 제한하거나 종료할 수 있습니다.</p>

            <p><b>종료의 효과:</b> 종료 시 서비스 이용 권한은 즉시 중지되며, 지적재산권, 면책, 책임 제한 조항은 계속 유효합니다.</p>

            <h2 className="text-xl font-bold mt-4">준거법 및 분쟁 해결</h2>
            <p><b>준거법:</b> 본 약관은 [관할지역] 법률에 따라 해석되며, 법률 충돌 원칙은 적용하지 않습니다.</p>

            <p><b>분쟁 해결:</b> 본 약관 및 서비스 이용과 관련한 분쟁은 [중재기관] 규칙에 따른 구속력 있는 중재로 해결하며, 소액 청구 법원은 예외입니다.</p>

            <p><b>집단소송 포기:</b> 귀하는 분쟁을 개별적으로 해결하며 집단 소송 또는 집단 중재에 참여할 권리를 포기합니다.</p>

            <h2 className="text-xl font-bold mt-4">기타</h2>
            <p><b>완전합의:</b> 본 약관과 개인정보처리방침이 귀하와 당사 간 서비스 이용에 관한 완전한 합의를 구성합니다.</p>

            <p><b>분리 가능성:</b> 본 약관의 일부 조항이 무효가 되더라도 나머지 조항은 계속 유효합니다.</p>

            <p><b>권리 포기 없음:</b> 당사가 본 약관을 집행하지 않는 것은 해당 조항 또는 기타 조항의 권리 포기로 간주되지 않습니다.</p>

            <p><b>양도:</b> 당사는 귀하의 동의 없이 본 약관상의 권리와 의무를 양도할 수 있으며, 귀하는 당사의 서면 동의 없이는 권리를 양도할 수 없습니다.</p>

            <h2 className="text-xl font-bold mt-4">연락처 정보</h2>
            <p>본 서비스 이용약관에 관한 문의는 아래로 연락해 주십시오:</p>

            <p><b>이메일:</b> <a href="mailto:prosense@prosense.co.kr">prosense@prosense.co.kr</a><br />
            <b>응답 시간:</b> 영업일 기준 5일 이내에 답변해 드리겠습니다.</p>

            <p><b>{SiteInfo.siteName}을 이용함으로써 귀하는 본 서비스 이용약관을 읽고 이해하였으며 이에 동의함을 인정합니다.</b></p>
          </>
        );
      case 'ja':
        return (
          <>
            <h1 className="text-2xl font-bold">利用規約</h1>

            <h2 className="text-xl font-bold mt-4">規約への同意</h2>
            <p>{SiteInfo.siteName}へようこそ。本利用規約（以下「規約」といいます）は、当社のウェブサイトおよびサービスのご利用に適用されます。ウェブサイトにアクセスまたはご利用いただくことで、本規約および当社のプライバシーポリシーに同意したものとみなされます。<b>本規約に同意されない場合は、サービスのご利用をお控えください。</b></p>

            <p><b>最終更新日：</b>本規約は{lastUpdated}に最終更新されており、随時変更される場合があります。変更後もサービスのご利用を継続される場合、新しい規約に同意したものとみなされます。</p>

            <h2 className="text-xl font-bold mt-4">サービスの説明</h2>
            <p>{SiteInfo.siteName}は、<b>取引キュレーションおよびアフィリエイトマーケティングプラットフォーム</b>であり、AliExpressやその他のECプラットフォームから厳選された商品をユーザーにおすすめします。サービス内容は以下の通りです：</p>

            <p><b>取引キュレーション：</b>割引率、販売実績、品質評価、販売者の信頼性をもとに独自のアルゴリズムで最適な取引を分析・提供します。</p>

            <p><b>アフィリエイトリンク：</b>ユーザーを提携するECプラットフォームの購入ページへリンクし、そのリンク経由の購入により当社はコミッションを受け取る場合があります。</p>

            <p><b>情報提供サービス：</b>商品情報や価格データ、分析を提供し、ユーザーの購入判断をサポートします。</p>

            <h2 className="text-xl font-bold mt-4">アフィリエイト開示</h2>
            <p><b>重要なお知らせ：</b>{SiteInfo.siteName}はアフィリエイトプログラムに参加しています。商品リンクをクリックし購入されると、追加費用なく販売者からコミッションを受け取る場合があります。</p>

            <p><b>コミッション構造：</b>当社の収益は購入完了に基づき、ユーザーの支払価格には影響しません。コミッションはサービス運営と無料キュレーション提供の維持に役立てられます。</p>

            <p><b>編集の独立性：</b>コミッションを受け取っても、取引の選定およびランキングは客観的な評価アルゴリズムに基づき、コミッション率や商業的関係に左右されません。</p>

            <h2 className="text-xl font-bold mt-4">ユーザーの責任</h2>
            <p>サービス利用者として、以下に同意するものとします：</p>

            <p><b>合法的利用：</b>本ウェブサイトを合法的な目的かつ本規約および適用される法律に従って利用すること。</p>

            <p><b>正確な情報提供：</b>お問い合わせやウェブサイトの対話機能使用時に正確な情報を提供すること。</p>

            <p><b>アカウントの安全管理：</b>アカウントやプロフィールを作成した場合は、ログイン情報を安全に管理し、不正アクセスを発見したら直ちに当社に通知すること。</p>

            <p><b>禁止行為：</b>ウェブサイトを破壊、過負荷、障害を与えたり、他のユーザーのサービス利用を妨害する行為をしないこと。</p>

            <p><b>遵守事項：</b>アフィリエイトリンク経由の購入時は、第三者プラットフォーム（例：AliExpress）のサービス規約およびポリシーを遵守すること。</p>

            <h2 className="text-xl font-bold mt-4">禁止される利用</h2>
            <p>以下の目的での本ウェブサイトの利用は禁止します：</p>

            <p><b>自動アクセス：</b>当社の明示的な書面許可なく、ボットやスクレイパー、または自動化システムを使ってウェブサイトへアクセスしたりデータを抽出すること。</p>

            <p><b>商業的利用：</b>無断でコンテンツを複製、コピー、販売、商業目的で利用すること。</p>

            <p><b>知的財産権の侵害：</b>当社または第三者の知的財産権を侵害する行為。</p>

            <p><b>不正行為：</b>アフィリエイト追跡システムの操作など、詐欺的、誤解を招く行為。</p>

            <p><b>システム妨害：</b>ウェブサイトのセキュリティやサーバー、ネットワークへの妨害行為。</p>

            <h2 className="text-xl font-bold mt-4">知的財産権</h2>
            <p><b>当社のコンテンツ：</b>{SiteInfo.siteName}上のすべてのコンテンツ（テキスト、画像、ロゴ、アルゴリズム、ソフトウェア等）は当社またはライセンサーの所有物であり、著作権、商標権およびその他の知的財産権により保護されています。</p>

            <p><b>限定ライセンス：</b>本規約に従い、個人的かつ非商業的な目的で当ウェブサイトにアクセス・利用する非独占的かつ譲渡不可の限定ライセンスを付与します。</p>

            <p><b>第三者コンテンツ：</b>第三者プラットフォームの製品画像や説明などはそれぞれの所有者が所有し、適用される契約および公正使用の原則に基づき利用しています。</p>

            <p><b>ユーザーコンテンツ：</b>ご提供いただいたコンテンツ（フィードバックや通信等）はサービス改善のために利用される場合があり、当社に対して非独占的な利用許諾を付与するものとします。</p>

            <h2 className="text-xl font-bold mt-4">免責事項および責任制限</h2>
            <p><b>サービスの可用性：</b>継続的なサービス提供に努めますが、常時のアクセスを保証するものではありません。メンテナンス、更新、技術的問題により一時的に利用不可となる場合があります。</p>

            <p><b>情報の正確性：</b>正確で最新の情報提供に努めますが、すべての商品情報、価格、在庫の完全性、正確性、タイムリーさは保証しません。</p>

            <p><b>第三者取引：</b>当社はユーザーと第三者販売者間の取引当事者ではなく、製品品質、配送、返品、カスタマーサービスには責任を負いません。</p>

            <p><b>無保証：</b>本サービスは「現状のまま」かつ「利用可能な範囲で」提供されており、明示的または黙示的な保証（商品性、特定目的適合性、非侵害など）を含みません。</p>

            <p><b>責任制限：</b>法令で許される最大限の範囲で、間接的、付随的、特別、結果的、懲罰的損害について一切責任を負いません（利益、データ、事業機会の損失を含む）。</p>

            <h2 className="text-xl font-bold mt-4">第三者サービス</h2>
            <p><b>外部リンク：</b>当ウェブサイトには第三者のウェブサイトやサービスへのリンクが含まれており、当社はそれらのコンテンツ、プライバシーポリシー、運用について責任を負いません。</p>

            <p><b>販売者との関係：</b>ユーザーと販売者（例：AliExpress）との関係は当社とは独立しており、購入に関する紛争は直接販売者と解決してください。</p>

            <p><b>第三者の規約：</b>当社のリンク経由で第三者サービスを利用する場合、当該第三者の利用規約およびポリシーも適用されます。</p>

            <h2 className="text-xl font-bold mt-4">データとプライバシー</h2>
            <p>お客様のプライバシーは重要です。当社の個人情報の収集、利用、保護はプライバシーポリシーに準拠しており、本規約に組み込まれています。<b>プライバシーポリシーを必ずご確認ください。</b></p>

            <p><b>データ利用：</b>個人を特定できない集計データは、分析、サービス改善、事業目的で使用される場合があります。</p>

            <p><b>クッキー：</b>プライバシーポリシーに記載の通り、クッキーや類似技術を使用しており、ウェブサイト利用時にこれに同意したものとみなされます。</p>

            <h2 className="text-xl font-bold mt-4">サービスの変更</h2>
            <p>当社は事前通知なくサービスの全部または一部を変更、一時停止または終了する権利を保有します。主な内容は以下の通りです：</p>

            <p><b>アルゴリズム更新：</b>サービス品質向上のための取引評価・キュレーションアルゴリズムの変更。</p>

            <p><b>機能変更：</b>ウェブサイトの機能追加、変更、削除。</p>

            <p><b>パートナー関係：</b>アフィリエイトパートナーシップや提供取引の変更。</p>

            <p>利用に重大な影響を与える変更については合理的に通知します。</p>

            <h2 className="text-xl font-bold mt-4">契約終了</h2>
            <p><b>ユーザーによる終了：</b>いつでも通知なしにサービスの利用を中止できます。</p>

            <p><b>当社による終了：</b>規約違反やサービスまたは他のユーザーに有害な行為があった場合、事前通知なく利用を停止または終了できます。</p>

            <p><b>終了の効果：</b>終了時点でサービス利用権は即時消滅し、知的財産権、免責、責任制限に関する条項は存続します。</p>

            <h2 className="text-xl font-bold mt-4">準拠法および紛争解決</h2>
            <p><b>準拠法：</b>本規約は[管轄地域]の法令に準拠し解釈され、法の抵触原則は適用されません。</p>

            <p><b>紛争解決：</b>本規約またはサービス利用に関する紛争は、[仲裁機関]の規則に基づく拘束力のある仲裁で解決し、小額訴訟裁判所は例外です。</p>

            <p><b>集団訴訟の放棄：</b>紛争は個別に解決し、集団訴訟や集団仲裁への参加権を放棄します。</p>

            <h2 className="text-xl font-bold mt-4">その他</h2>
            <p><b>完全合意：</b>本規約とプライバシーポリシーは、サービス利用に関する当社とお客様間の完全な合意を構成します。</p>

            <p><b>分離可能性：</b>本規約のいずれかの条項が無効とされた場合でも、他の条項は完全に有効です。</p>

            <p><b>権利放棄なし：</b>当社が規約のいずれかの条項を行使しない場合でも、権利放棄とはみなされません。</p>

            <p><b>譲渡：</b>当社はお客様の同意なしに本規約上の権利義務を譲渡でき、お客様は当社の書面同意なしに権利を譲渡できません。</p>

            <h2 className="text-xl font-bold mt-4">お問い合わせ先</h2>
            <p>本利用規約についてご質問がある場合は、以下までご連絡ください：</p>

            <p><b>メールアドレス：</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>対応時間：</b>5営業日以内に回答いたします。</p>

            <p><b>{SiteInfo.siteName}をご利用いただくことで、本利用規約を読み、理解し、同意したことを確認したものとします。</b></p>
          </>
        );
      case 'es-ES':
        return (
          <>
            <h1 className="text-2xl font-bold">Términos de Servicio</h1>

            <h2 className="text-xl font-bold mt-4">Acuerdo con los Términos</h2>
            <p>Bienvenido a {SiteInfo.siteName}. Estos Términos de Servicio (&quot;Términos&quot;) rigen su uso de nuestro sitio web y servicios. Al acceder o usar nuestro sitio web, usted acepta estar sujeto a estos Términos y a nuestra Política de Privacidad. <b>Si no está de acuerdo con estos Términos, por favor no utilice nuestros servicios.</b></p>

            <p><b>Última actualización:</b> Estos Términos fueron actualizados por última vez el {lastUpdated} y pueden modificarse ocasionalmente. El uso continuado de nuestros servicios después de cualquier cambio constituye la aceptación de los nuevos Términos.</p>

            <h2 className="text-xl font-bold mt-4">Descripción del Servicio</h2>
            <p>{SiteInfo.siteName} es una <b>plataforma de curación de ofertas y marketing de afiliados</b> que proporciona a los usuarios recomendaciones de productos seleccionados de AliExpress y otras plataformas de comercio electrónico. Nuestro servicio incluye:</p>

            <p><b>Curación de ofertas:</b> Analizamos productos usando nuestro algoritmo propietario para identificar y presentar las mejores ofertas basadas en tasas de descuento, desempeño de ventas, calificaciones de calidad y credibilidad del vendedor.</p>

            <p><b>Enlaces de afiliados:</b> Proporcionamos enlaces a plataformas de comercio electrónico de terceros donde puede comprar los productos destacados. Podemos ganar comisiones por compras calificadas realizadas a través de estos enlaces.</p>

            <p><b>Servicio de información:</b> Proporcionamos información de productos, datos de precios y análisis para ayudar a los usuarios a tomar decisiones informadas de compra.</p>

            <h2 className="text-xl font-bold mt-4">Divulgación de Afiliados</h2>
            <p><b>Aviso importante:</b> {SiteInfo.siteName} participa en programas de marketing de afiliados. Cuando hace clic en enlaces de productos y realiza compras a través de nuestro sitio web, podemos ganar una comisión del comerciante sin costo adicional para usted.</p>

            <p><b>Estructura de comisiones:</b> Nuestros ingresos se basan en compras completadas y no influyen en el precio que usted paga. La comisión que recibimos ayuda a mantener nuestro servicio y nos permite continuar proporcionando curación gratuita de ofertas a los usuarios.</p>

            <p><b>Independencia editorial:</b> Aunque recibimos comisiones por enlaces de afiliados, la selección y clasificación de ofertas se basa en nuestro algoritmo de puntuación objetiva y no está influenciada por tasas de comisión o relaciones comerciales.</p>

            <h2 className="text-xl font-bold mt-4">Responsabilidades del Usuario</h2>
            <p>Como usuario de nuestro servicio, usted acepta:</p>

            <p><b>Uso legal:</b> Utilizar nuestro sitio web solo para fines legales y de acuerdo con estos Términos y las leyes y regulaciones aplicables.</p>

            <p><b>Información precisa:</b> Proporcionar información precisa al contactarnos o usar cualquier función interactiva de nuestro sitio web.</p>

            <p><b>Seguridad de la cuenta:</b> Si crea una cuenta o perfil, mantener la seguridad de sus credenciales de inicio de sesión y notificarnos inmediatamente cualquier acceso no autorizado.</p>

            <p><b>Actividades prohibidas:</b> No participar en actividades que puedan dañar, deshabilitar, sobrecargar o afectar nuestro sitio web o interferir con el disfrute de nuestros servicios por parte de otros usuarios.</p>

            <p><b>Cumplimiento:</b> Cumplir con los términos de servicio y políticas de plataformas de terceros (como AliExpress) al realizar compras a través de nuestros enlaces de afiliados.</p>

            <h2 className="text-xl font-bold mt-4">Usos prohibidos</h2>
            <p>No puede usar nuestro sitio web para ninguno de los siguientes fines prohibidos:</p>

            <p><b>Acceso automatizado:</b> Usar bots, scrapers o sistemas automatizados para acceder a nuestro sitio web o extraer datos sin nuestro permiso expreso por escrito.</p>

            <p><b>Explotación comercial:</b> Reproducir, duplicar, copiar, vender o explotar nuestro contenido con fines comerciales sin autorización.</p>

            <p><b>Infracción de propiedad intelectual:</b> Violar nuestros derechos de propiedad intelectual o los de terceros.</p>

            <p><b>Actividad fraudulenta:</b> Participar en prácticas fraudulentas, engañosas o falsas, incluyendo la manipulación de nuestros sistemas de seguimiento de afiliados.</p>

            <p><b>Interferencia con el sistema:</b> Intentar interferir, comprometer o interrumpir la seguridad, servidores o redes de nuestro sitio web.</p>

            <h2 className="text-xl font-bold mt-4">Derechos de propiedad intelectual</h2>
            <p><b>Nuestro contenido:</b> Todo el contenido en {SiteInfo.siteName}, incluidos textos, gráficos, logotipos, algoritmos y software, es propiedad nuestra o de nuestros licenciantes y está protegido por derechos de autor, marcas registradas y otras leyes de propiedad intelectual.</p>

            <p><b>Licencia limitada:</b> Le otorgamos una licencia limitada, no exclusiva e intransferible para acceder y usar nuestro sitio web para fines personales y no comerciales, de acuerdo con estos Términos.</p>

            <p><b>Contenido de terceros:</b> Las imágenes de productos, descripciones y otro contenido de plataformas de terceros son propiedad de sus respectivos dueños y se usan de acuerdo con los acuerdos aplicables y principios de uso justo.</p>

            <p><b>Contenido de usuarios:</b> Cualquier contenido que usted nos envíe (como comentarios o comunicaciones) puede ser utilizado por nosotros para fines de mejora del servicio, y usted nos concede una licencia no exclusiva para usar dicho contenido.</p>

            <h2 className="text-xl font-bold mt-4">Exenciones de responsabilidad y limitación de responsabilidad</h2>
            <p><b>Disponibilidad del servicio:</b> Nos esforzamos por mantener la disponibilidad continua del servicio, pero no garantizamos acceso ininterrumpido. Nuestro sitio web puede estar temporalmente no disponible por mantenimiento, actualizaciones o problemas técnicos.</p>

            <p><b>Exactitud de la información:</b> Aunque hacemos todo lo posible por proporcionar información precisa y actualizada, no podemos garantizar la exactitud, integridad o puntualidad de toda la información de productos, precios o disponibilidad.</p>

            <p><b>Transacciones con terceros:</b> No somos parte en las transacciones entre usted y los comerciantes terceros. Todas las compras se realizan directamente con el comerciante, y no somos responsables por la calidad del producto, entrega, devoluciones o servicio al cliente.</p>

            <p><b>SIN GARANTÍAS:</b> Nuestro servicio se proporciona &quot;tal cual&quot; y &quot;según disponibilidad&quot; sin garantías de ningún tipo, ya sean expresas o implícitas, incluyendo, entre otras, garantías de comerciabilidad, idoneidad para un propósito particular o no infracción.</p>

            <p><b>Limitación de responsabilidad:</b> En la máxima medida permitida por la ley, no seremos responsables por daños indirectos, incidentales, especiales, consecuentes o punitivos, incluyendo pero no limitados a pérdida de ganancias, datos o oportunidades de negocio.</p>

            <h2 className="text-xl font-bold mt-4">Servicios de terceros</h2>
            <p><b>Enlaces externos:</b> Nuestro sitio contiene enlaces a sitios web y servicios de terceros. No somos responsables por el contenido, políticas de privacidad o prácticas de estos sitios externos.</p>

            <p><b>Relaciones con comerciantes:</b> Su relación con comerciantes (como AliExpress) es independiente de su relación con nosotros. Cualquier disputa sobre compras debe resolverse directamente con el comerciante correspondiente.</p>

            <p><b>Términos de terceros:</b> Al usar servicios de terceros a través de nuestros enlaces, usted está sujeto a sus respectivos términos de servicio y políticas además de los nuestros.</p>

            <h2 className="text-xl font-bold mt-4">Datos y privacidad</h2>
            <p>Su privacidad es importante para nosotros. La recopilación, uso y protección de su información personal están regidos por nuestra Política de Privacidad, que se incorpora a estos Términos por referencia. <b>Por favor, revise nuestra Política de Privacidad</b> para entender nuestras prácticas de datos.</p>

            <p><b>Uso de datos:</b> Podemos usar datos agregados y no identificables personalmente para análisis, mejora del servicio y propósitos comerciales.</p>

            <p><b>Cookies:</b> Usamos cookies y tecnologías similares según se describe en nuestra Política de Privacidad. Al usar nuestro sitio, usted consiente el uso de cookies conforme a nuestras políticas.</p>

            <h2 className="text-xl font-bold mt-4">Modificaciones al servicio</h2>
            <p>Nos reservamos el derecho de modificar, suspender o discontinuar cualquier aspecto de nuestro servicio en cualquier momento sin previo aviso. Esto incluye pero no se limita a:</p>

            <p><b>Actualizaciones del algoritmo:</b> Cambios en nuestros algoritmos de puntuación y curación para mejorar la calidad del servicio.</p>

            <p><b>Cambios en funciones:</b> Adición, modificación o eliminación de funciones y funcionalidades del sitio web.</p>

            <p><b>Relaciones con socios:</b> Cambios en nuestras asociaciones de afiliados y ofertas disponibles.</p>

            <p>Haremos esfuerzos razonables para notificar a los usuarios sobre cambios significativos que puedan afectar su uso de nuestros servicios.</p>

            <h2 className="text-xl font-bold mt-4">Terminación</h2>
            <p><b>Terminación por parte del usuario:</b> Usted puede dejar de usar nuestros servicios en cualquier momento sin previo aviso.</p>

            <p><b>Terminación por nuestra parte:</b> Podemos terminar o suspender su acceso a nuestros servicios inmediatamente, sin previo aviso, si viola estos Términos o participa en conductas que determinemos son dañinas para nuestro servicio o para otros usuarios.</p>

            <p><b>Efecto de la terminación:</b> Tras la terminación, su derecho a usar nuestros servicios cesará inmediatamente, pero las disposiciones relacionadas con propiedad intelectual, exenciones de responsabilidad y limitación de responsabilidad continuarán vigentes.</p>

            <h2 className="text-xl font-bold mt-4">Ley aplicable y resolución de disputas</h2>
            <p><b>Ley aplicable:</b> Estos Términos se rigen e interpretan de acuerdo con las leyes de [JURISDICCIÓN], sin considerar principios de conflicto de leyes.</p>

            <p><b>Resolución de disputas:</b> Cualquier disputa derivada de estos Términos o del uso de nuestros servicios se resolverá mediante arbitraje vinculante conforme a las reglas de [ORGANISMO DE ARBITRAJE], salvo asuntos que puedan ser llevados a tribunales de reclamos menores.</p>

            <p><b>Renuncia a acciones colectivas:</b> Usted acuerda resolver disputas individualmente y renuncia a cualquier derecho a participar en demandas colectivas o arbitrajes colectivos.</p>

            <h2 className="text-xl font-bold mt-4">Misceláneos</h2>
            <p><b>Acuerdo completo:</b> Estos Términos, junto con nuestra Política de Privacidad, constituyen el acuerdo completo entre usted y nosotros respecto al uso de nuestros servicios.</p>

            <p><b>Divisibilidad:</b> Si alguna disposición de estos Términos es considerada inaplicable, las disposiciones restantes permanecerán en pleno vigor y efecto.</p>

            <p><b>No renuncia:</b> Nuestra falta de hacer cumplir cualquier disposición no constituye una renuncia a esa disposición o a cualquier otra.</p>

            <p><b>Cesión:</b> Podemos ceder nuestros derechos y obligaciones bajo estos Términos sin su consentimiento. Usted no puede ceder sus derechos bajo estos Términos sin nuestro consentimiento por escrito.</p>

            <h2 className="text-xl font-bold mt-4">Información de contacto</h2>
            <p>Si tiene preguntas sobre estos Términos de Servicio, por favor contáctenos en:</p>

            <p><b>Email:</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>Tiempo de respuesta:</b> Responderemos a las consultas dentro de 5 días hábiles.</p>

            <p><b>Al usar {SiteInfo.siteName}, usted reconoce que ha leído, entendido y acepta estar sujeto a estos Términos de Servicio.</b></p>
          </>
        );
      case 'ru':
        return (
          <>
            <h1 className="text-2xl font-bold">Условия использования</h1>

            <h2 className="text-xl font-bold mt-4">Согласие с условиями</h2>
            <p>Добро пожаловать на {SiteInfo.siteName}. Настоящие Условия использования (&quot;Условия&quot;) регулируют ваше использование нашего веб-сайта и услуг. Получая доступ или используя наш сайт, вы соглашаетесь соблюдать эти Условия и нашу Политику конфиденциальности. <b>Если вы не согласны с этими Условиями, пожалуйста, не используйте наши услуги.</b></p>

            <p><b>Дата последнего обновления:</b> Эти Условия были обновлены {lastUpdated} и могут время от времени изменяться. Ваше дальнейшее использование наших услуг после любых изменений означает принятие новых Условий.</p>

            <h2 className="text-xl font-bold mt-4">Описание услуги</h2>
            <p>{SiteInfo.siteName} — это <b>платформа для отбора выгодных предложений и партнёрского маркетинга</b>, которая предоставляет пользователям рекомендации по товарам с AliExpress и других платформ электронной коммерции. Наш сервис включает:</p>

            <p><b>Отбор предложений:</b> Мы анализируем товары с помощью собственного алгоритма, чтобы выявлять и представлять лучшие предложения на основе скидок, объёмов продаж, рейтингов качества и надёжности продавцов.</p>

            <p><b>Партнёрские ссылки:</b> Мы предоставляем ссылки на сторонние платформы электронной коммерции, где вы можете приобрести указанные товары. Мы можем получать комиссию с квалифицированных покупок, сделанных через эти ссылки.</p>

            <p><b>Информационный сервис:</b> Мы предоставляем информацию о товарах, данные о ценах и аналитические материалы, чтобы помочь пользователям принимать обоснованные решения при покупке.</p>

            <h2 className="text-xl font-bold mt-4">Раскрытие информации о партнёрстве</h2>
            <p><b>Важное уведомление:</b> {SiteInfo.siteName} участвует в программах партнёрского маркетинга. Когда вы переходите по ссылкам на товары и совершаете покупки через наш сайт, мы можем получать комиссию от продавца без дополнительных затрат для вас.</p>

            <p><b>Структура комиссий:</b> Наш доход основан на завершённых покупках и не влияет на цену, которую вы платите. Получаемая комиссия помогает поддерживать работу сервиса и позволяет продолжать предоставлять пользователям бесплатный отбор выгодных предложений.</p>

            <p><b>Редакционная независимость:</b> Несмотря на получение комиссий по партнёрским ссылкам, выбор и рейтинг предложений основываются на объективном алгоритме оценки и не зависят от размеров комиссий или коммерческих отношений.</p>

            <h2 className="text-xl font-bold mt-4">Обязанности пользователя</h2>
            <p>В качестве пользователя нашего сервиса вы соглашаетесь:</p>

            <p><b>Законное использование:</b> Использовать наш сайт только в законных целях и в соответствии с этими Условиями, а также применимыми законами и нормативами.</p>

            <p><b>Точная информация:</b> Предоставлять точную информацию при обращении к нам или использовании любых интерактивных функций сайта.</p>

            <p><b>Безопасность аккаунта:</b> Если вы создаёте аккаунт или профиль, обеспечивать безопасность своих данных для входа и незамедлительно сообщать нам о несанкционированном доступе.</p>

            <p><b>Запрещённые действия:</b> Не предпринимать действий, которые могут повредить, отключить, перегрузить или нарушить работу сайта, а также мешать другим пользователям пользоваться сервисом.</p>

            <p><b>Соблюдение правил:</b> Соблюдать условия использования и политики третьих платформ (например, AliExpress) при совершении покупок через наши партнёрские ссылки.</p>

            <h2 className="text-xl font-bold mt-4">Запрещённое использование</h2>
            <p>Вам запрещается использовать наш сайт для следующих целей:</p>

            <p><b>Автоматизированный доступ:</b> Использование ботов, скреперов или автоматизированных систем для доступа к сайту или извлечения данных без нашего письменного разрешения.</p>

            <p><b>Коммерческая эксплуатация:</b> Воспроизведение, дублирование, копирование, продажа или иное коммерческое использование нашего контента без разрешения.</p>

            <p><b>Нарушение интеллектуальной собственности:</b> Нарушение наших прав на интеллектуальную собственность или прав третьих лиц.</p>

            <p><b>Мошенническая деятельность:</b> Участие в мошеннических, вводящих в заблуждение или обманных действиях, включая манипуляцию системами отслеживания партнёрских ссылок.</p>

            <p><b>Вмешательство в систему:</b> Попытки вмешательства, компрометации или нарушения безопасности, серверов или сетей сайта.</p>

            <h2 className="text-xl font-bold mt-4">Права интеллектуальной собственности</h2>
            <p><b>Наш контент:</b> Весь контент на {SiteInfo.siteName}, включая тексты, графику, логотипы, алгоритмы и программное обеспечение, является нашей собственностью или собственностью наших лицензиаров и защищён авторским правом, товарными знаками и другими законами об интеллектуальной собственности.</p>

            <p><b>Ограниченная лицензия:</b> Мы предоставляем вам ограниченную, неисключительную, непередаваемую лицензию на доступ и использование нашего сайта в личных, некоммерческих целях в соответствии с настоящими Условиями.</p>

            <p><b>Контент третьих лиц:</b> Изображения продуктов, описания и другой контент с платформ третьих лиц принадлежат их владельцам и используются в соответствии с применимыми соглашениями и принципами добросовестного использования.</p>

            <p><b>Контент пользователя:</b> Любой контент, который вы предоставляете нам (например, отзывы или сообщения), может быть использован нами для улучшения сервиса, и вы предоставляете нам неисключительную лицензию на использование такого контента.</p>

            <h2 className="text-xl font-bold mt-4">Отказы и ограничение ответственности</h2>
            <p><b>Доступность сервиса:</b> Мы стремимся обеспечить непрерывную доступность сервиса, но не гарантируем бесперебойный доступ. Наш сайт может быть временно недоступен из-за обслуживания, обновлений или технических проблем.</p>

            <p><b>Точность информации:</b> Мы прилагаем все усилия для предоставления точной и актуальной информации, но не гарантируем точность, полноту или своевременность всей информации о продуктах, ценах или наличии.</p>

            <p><b>Транзакции с третьими лицами:</b> Мы не являемся стороной сделок между вами и третьими продавцами. Все покупки осуществляются непосредственно с продавцом, и мы не несем ответственности за качество продукта, доставку, возвраты или обслуживание клиентов.</p>

            <p><b>БЕЗ ГАРАНТИЙ:</b> Наш сервис предоставляется «как есть» и «по доступности» без каких-либо гарантий, явных или подразумеваемых, включая, но не ограничиваясь, гарантии товарной пригодности, пригодности для определённой цели или отсутствия нарушений.</p>

            <p><b>Ограничение ответственности:</b> В максимально допустимой законом степени мы не несем ответственности за любые косвенные, случайные, специальные, последовательные или штрафные убытки, включая, но не ограничиваясь, упущенной выгодой, потерей данных или деловых возможностей.</p>

            <h2 className="text-xl font-bold mt-4">Сервисы третьих лиц</h2>
            <p><b>Внешние ссылки:</b> Наш сайт содержит ссылки на сторонние сайты и сервисы. Мы не несем ответственности за содержание, политики конфиденциальности или практики этих внешних сайтов.</p>

            <p><b>Отношения с продавцами:</b> Ваши отношения с продавцами (например, AliExpress) независимы от отношений с нами. Все споры по покупкам должны решаться непосредственно с соответствующим продавцом.</p>

            <p><b>Условия третьих лиц:</b> При использовании сервисов третьих лиц через наши ссылки вы также подчиняетесь их условиям обслуживания и политикам в дополнение к нашим.</p>

            <h2 className="text-xl font-bold mt-4">Данные и конфиденциальность</h2>
            <p>Ваша конфиденциальность важна для нас. Наш сбор, использование и защита вашей личной информации регулируется нашей Политикой конфиденциальности, которая включена в эти Условия по ссылке. <b>Пожалуйста, ознакомьтесь с нашей Политикой конфиденциальности</b> чтобы понять наши методы работы с данными.</p>

            <p><b>Использование данных:</b> Мы можем использовать агрегированные, не идентифицируемые личность данные для аналитики, улучшения сервиса и деловых целей.</p>

            <p><b>Файлы cookie:</b> Мы используем файлы cookie и аналогичные технологии, как описано в нашей Политике конфиденциальности. Используя наш сайт, вы соглашаетесь на использование нами cookie согласно нашей политике.</p>

            <h2 className="text-xl font-bold mt-4">Изменения в сервисе</h2>
            <p>Мы оставляем за собой право изменять, приостанавливать или прекращать любой аспект нашего сервиса в любое время без предварительного уведомления. Это включает, но не ограничивается:</p>

            <p><b>Обновления алгоритмов:</b> Изменения в наших алгоритмах оценки и отбора сделок для улучшения качества сервиса.</p>

            <p><b>Изменения функций:</b> Добавление, изменение или удаление функций и возможностей сайта.</p>

            <p><b>Партнёрские отношения:</b> Изменения в наших партнёрских программах и доступных сделках.</p>

            <p>Мы предпримем разумные усилия для уведомления пользователей о значительных изменениях, которые могут повлиять на их использование наших услуг.</p>

            <h2 className="text-xl font-bold mt-4">Прекращение</h2>
            <p><b>Прекращение пользователем:</b> Вы можете прекратить использование наших услуг в любое время без уведомления.</p>

            <p><b>Прекращение нами:</b> Мы можем немедленно прекратить или приостановить ваш доступ к услугам без предварительного уведомления, если вы нарушаете эти Условия или ведёте себя таким образом, который мы считаем вредным для нашего сервиса или других пользователей.</p>

            <p><b>Последствия прекращения:</b> После прекращения ваше право использовать наши услуги прекращается немедленно, однако положения, касающиеся интеллектуальной собственности, отказов от ответственности и ограничений ответственности остаются в силе.</p>

            <h2 className="text-xl font-bold mt-4">Применимое право и разрешение споров</h2>
            <p><b>Применимое право:</b> Настоящие Условия регулируются и толкуются в соответствии с законодательством [ЮРИСДИКЦИИ], без учёта коллизионных норм.</p>

            <p><b>Разрешение споров:</b> Любые споры, возникающие из настоящих Условий или вашего использования наших услуг, будут разрешаться посредством обязательного арбитража в соответствии с правилами [АРБИТРАЖНОЙ ОРГАНИЗАЦИИ], за исключением дел, которые могут быть рассмотрены в суде мелких исков.</p>

            <p><b>Отказ от коллективных исков:</b> Вы соглашаетесь решать споры индивидуально и отказываетесь от права участвовать в коллективных исках или коллективном арбитраже.</p>

            <h2 className="text-xl font-bold mt-4">Разное</h2>
            <p><b>Полное соглашение:</b> Эти Условия вместе с нашей Политикой конфиденциальности составляют полное соглашение между вами и нами относительно использования вами наших услуг.</p>

            <p><b>Разделимость:</b> Если какое-либо положение этих Условий признаётся недействительным, остальные положения остаются в полной силе.</p>

            <p><b>Отказ от прав:</b> Наше невыполнение какого-либо положения не означает отказ от этого или любого другого положения.</p>

            <p><b>Передача прав:</b> Мы можем передавать наши права и обязанности по этим Условиям без вашего согласия. Вы не можете передавать свои права по этим Условиям без нашего письменного согласия.</p>

            <h2 className="text-xl font-bold mt-4">Контактная информация</h2>
            <p>Если у вас есть вопросы по этим Условиям использования, пожалуйста, свяжитесь с нами:</p>

            <p><b>Электронная почта:</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>Время ответа:</b> Мы ответим на запросы в течение 5 рабочих дней.</p>

            <p><b>Используя {SiteInfo.siteName}, вы подтверждаете, что прочитали, поняли и соглашаетесь соблюдать эти Условия использования.</b></p>
          </>
        );
      default:
        return (
          <>
            <h1 className="text-2xl font-bold">Terms of Service</h1>

            <h2 className="text-xl font-bold mt-4">Agreement to Terms</h2>
            <p>Welcome to {SiteInfo.siteName}. These Terms of Service (&quot;Terms&quot;) govern your use of our website and services. By accessing or using our website, you agree to be bound by these Terms and our Privacy Policy. <b>If you do not agree to these Terms, please do not use our services.</b></p>

            <p><b>Last Updated:</b> These Terms were last updated on {lastUpdated} and may be modified from time to time. Your continued use of our services after any changes constitutes acceptance of the new Terms.</p>

            <h2 className="text-xl font-bold mt-4">Description of Service</h2>
            <p>{SiteInfo.siteName} is a <b>deal curation and affiliate marketing platform</b> that provides users with curated product recommendations from AliExpress and other e-commerce platforms. Our service includes:</p>

            <p><b>Deal Curation:</b> We analyze products using our proprietary algorithm to identify and present the best deals based on discount rates, sales performance, quality ratings, and seller credibility.</p>

            <p><b>Affiliate Links:</b> We provide links to third-party e-commerce platforms where you can purchase featured products. We may earn commissions from qualifying purchases made through these links.</p>

            <p><b>Information Service:</b> We provide product information, pricing data, and analysis to help users make informed purchasing decisions.</p>

            <h2 className="text-xl font-bold mt-4">Affiliate Disclosure</h2>
            <p><b>Important Notice:</b> {SiteInfo.siteName} participates in affiliate marketing programs. When you click on product links and make purchases through our website, we may earn a commission from the merchant at no additional cost to you.</p>

            <p><b>Commission Structure:</b> Our earnings are based on completed purchases and do not influence the price you pay. The commission we receive helps support our service and allows us to continue providing free deal curation to users.</p>

            <p><b>Editorial Independence:</b> While we earn commissions from affiliate links, our deal selection and ranking are based on our objective scoring algorithm and are not influenced by commission rates or commercial relationships.</p>

            <h2 className="text-xl font-bold mt-4">User Responsibilities</h2>
            <p>As a user of our service, you agree to:</p>

            <p><b>Lawful Use:</b> Use our website only for lawful purposes and in accordance with these Terms and applicable laws and regulations.</p>

            <p><b>Accurate Information:</b> Provide accurate information when contacting us or using any interactive features of our website.</p>

            <p><b>Account Security:</b> If you create any account or profile, maintain the security of your login credentials and notify us immediately of any unauthorized access.</p>

            <p><b>Prohibited Activities:</b> Not engage in any activity that could harm, disable, overburden, or impair our website or interfere with other users&apos; enjoyment of our services.</p>

            <p><b>Compliance:</b> Comply with the terms of service and policies of third-party platforms (such as AliExpress) when making purchases through our affiliate links.</p>

            <h2 className="text-xl font-bold mt-4">Prohibited Uses</h2>
            <p>You may not use our website for any of the following prohibited purposes:</p>

            <p><b>Automated Access:</b> Use bots, scrapers, or automated systems to access our website or extract data without our express written permission.</p>

            <p><b>Commercial Exploitation:</b> Reproduce, duplicate, copy, sell, or exploit our content for commercial purposes without authorization.</p>

            <p><b>Intellectual Property Infringement:</b> Violate our intellectual property rights or those of third parties.</p>

            <p><b>Fraudulent Activity:</b> Engage in any fraudulent, deceptive, or misleading practices, including manipulation of our affiliate tracking systems.</p>

            <p><b>System Interference:</b> Attempt to interfere with, compromise, or disrupt our website&apos;s security, servers, or networks.</p>

            <h2 className="text-xl font-bold mt-4">Intellectual Property Rights</h2>
            <p><b>Our Content:</b> All content on {SiteInfo.siteName}, including text, graphics, logos, algorithms, and software, is owned by us or our licensors and is protected by copyright, trademark, and other intellectual property laws.</p>

            <p><b>Limited License:</b> We grant you a limited, non-exclusive, non-transferable license to access and use our website for personal, non-commercial purposes in accordance with these Terms.</p>

            <p><b>Third-Party Content:</b> Product images, descriptions, and other content from third-party platforms are owned by their respective owners and are used in accordance with applicable agreements and fair use principles.</p>

            <p><b>User Content:</b> Any content you submit to us (such as feedback or communications) may be used by us for service improvement purposes, and you grant us a non-exclusive license to use such content.</p>

            <h2 className="text-xl font-bold mt-4">Disclaimers and Limitation of Liability</h2>
            <p><b>Service Availability:</b> We strive to maintain continuous service availability but do not guarantee uninterrupted access. Our website may be temporarily unavailable due to maintenance, updates, or technical issues.</p>

            <p><b>Information Accuracy:</b> While we make every effort to provide accurate and up-to-date information, we cannot guarantee the accuracy, completeness, or timeliness of all product information, prices, or availability.</p>

            <p><b>Third-Party Transactions:</b> We are not a party to transactions between you and third-party merchants. All purchases are made directly with the merchant, and we are not responsible for product quality, delivery, returns, or customer service issues.</p>

            <p><b>NO WARRANTIES:</b> Our service is provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, either express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement.</p>

            <p><b>Limitation of Liability:</b> To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or business opportunities.</p>

            <h2 className="text-xl font-bold mt-4">Third-Party Services</h2>
            <p><b>External Links:</b> Our website contains links to third-party websites and services. We are not responsible for the content, privacy policies, or practices of these external sites.</p>

            <p><b>Merchant Relationships:</b> Your relationship with merchants (such as AliExpress) is independent of your relationship with us. Any disputes regarding purchases should be resolved directly with the relevant merchant.</p>

            <p><b>Third-Party Terms:</b> When using third-party services through our links, you are subject to their respective terms of service and policies in addition to ours.</p>

            <h2 className="text-xl font-bold mt-4">Data and Privacy</h2>
            <p>Your privacy is important to us. Our collection, use, and protection of your personal information is governed by our Privacy Policy, which is incorporated into these Terms by reference. <b>Please review our Privacy Policy</b> to understand our data practices.</p>

            <p><b>Data Usage:</b> We may use aggregated, non-personally identifiable data for analytics, service improvement, and business purposes.</p>

            <p><b>Cookies:</b> We use cookies and similar technologies as described in our Privacy Policy. By using our website, you consent to our use of cookies in accordance with our policies.</p>

            <h2 className="text-xl font-bold mt-4">Modifications to Service</h2>
            <p>We reserve the right to modify, suspend, or discontinue any aspect of our service at any time without prior notice. This includes but is not limited to:</p>

            <p><b>Algorithm Updates:</b> Changes to our deal scoring and curation algorithms to improve service quality.</p>

            <p><b>Feature Changes:</b> Addition, modification, or removal of website features and functionality.</p>

            <p><b>Partner Relationships:</b> Changes to our affiliate partnerships and available deals.</p>

            <p>We will make reasonable efforts to notify users of significant changes that may affect their use of our services.</p>

            <h2 className="text-xl font-bold mt-4">Termination</h2>
            <p><b>Termination by You:</b> You may stop using our services at any time without notice.</p>

            <p><b>Termination by Us:</b> We may terminate or suspend your access to our services immediately, without prior notice, if you violate these Terms or engage in conduct that we determine is harmful to our service or other users.</p>

            <p><b>Effect of Termination:</b> Upon termination, your right to use our services will cease immediately, but provisions regarding intellectual property, disclaimers, and limitation of liability will survive.</p>

            <h2 className="text-xl font-bold mt-4">Governing Law and Dispute Resolution</h2>
            <p><b>Governing Law:</b> These Terms are governed by and construed in accordance with the laws of [JURISDICTION], without regard to conflict of law principles.</p>

            <p><b>Dispute Resolution:</b> Any disputes arising from these Terms or your use of our services will be resolved through binding arbitration in accordance with the rules of [ARBITRATION ORGANIZATION], except for matters that may be brought in small claims court.</p>

            <p><b>Class Action Waiver:</b> You agree to resolve disputes individually and waive any right to participate in class action lawsuits or class-wide arbitration.</p>

            <h2 className="text-xl font-bold mt-4">Miscellaneous</h2>
            <p><b>Entire Agreement:</b> These Terms, together with our Privacy Policy, constitute the entire agreement between you and us regarding your use of our services.</p>

            <p><b>Severability:</b> If any provision of these Terms is found to be unenforceable, the remaining provisions will remain in full force and effect.</p>

            <p><b>No Waiver:</b> Our failure to enforce any provision of these Terms does not constitute a waiver of that provision or any other provision.</p>

            <p><b>Assignment:</b> We may assign our rights and obligations under these Terms without your consent. You may not assign your rights under these Terms without our written consent.</p>

            <h2 className="text-xl font-bold mt-4">Contact Information</h2>
            <p>If you have questions about these Terms of Service, please contact us at:</p>

            <p><b>Email:</b> <a href="mailto:support@{SiteInfo.siteName}">support@{SiteInfo.siteName}</a><br />
            <b>Response Time:</b> We will respond to inquiries within 5 business days.</p>

            <p><b>By using {SiteInfo.siteName}, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</b></p>
          </>
        );
    }
  }

  return (
    <>
      <Head>
        <title>{`${t("termsOfService")} | ${ SiteInfo.siteName }`}</title>
        <meta name="description" content={`${t("siteDescription")}`} />
        <link rel="canonical" href={`${props.siteUrl}/termsOfService`} />
        <meta name="robots" content="index, follow" />
      </Head>
      {getTermsOfServiceContent()}
    </>
  );
}